import gql from 'graphql-tag';

export default gql`
  mutation recordCheckPaymentForRegistration($input: CheckPaymentInput) {
    recordCheckPaymentForRegistration(input: $input) {
      id
    }
  }
`;
